import { useState } from "react";
import { adminUpdateItem } from "@/lib/api";
import { formatMoney } from "@/lib/orderUtils";

export const KioskDealsModal = ({ brand, onClose, onChanged }) => {
    const [busy, setBusy] = useState(null);
    const items = brand.items || [];
    const count = items.filter((i) => i.kiosk_deal).length;

    const toggle = async (it) => {
        setBusy(it.id);
        try { await adminUpdateItem(brand.id, it.id, { kiosk_deal: !it.kiosk_deal }); await onChanged(); }
        catch (e) { alert(e.response?.data?.detail || "Couldn't save. Try again."); }
        finally { setBusy(null); }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm grid place-items-center p-4" onClick={onClose} data-testid="kiosk-deals-modal">
            <div className="w-full max-w-xl max-h-[85vh] flex flex-col border border-[var(--border)] bg-[var(--surface)]" onClick={(e) => e.stopPropagation()}>
                <div className="p-6 border-b border-[var(--border)] flex items-start justify-between gap-4">
                    <div>
                        <p className="eyebrow">// Kiosk deals · {count} showing</p>
                        <h2 className="font-display text-[28px] leading-none mt-1">Show on kiosk</h2>
                        <p className="text-muted text-sm mt-2">Ticked items appear as slides between the logos on the kiosk start screen. Tapping one opens this brand's menu.</p>
                    </div>
                    <button onClick={onClose} className="btn-ghost" data-testid="kiosk-deals-close">Done</button>
                </div>
                <div className="overflow-y-auto divide-y divide-[var(--border)]">
                    {items.length === 0 && <p className="p-6 text-muted text-sm">No menu items yet.</p>}
                    {items.map((it) => (
                        <label key={it.id} className="flex items-center gap-4 px-6 py-3 cursor-pointer hover:bg-[var(--surface-elevated)]" data-testid={`kiosk-deal-row-${it.id}`}>
                            <input type="checkbox" className="w-5 h-5 accent-[var(--gold)]" checked={!!it.kiosk_deal} disabled={busy === it.id}
                                onChange={() => toggle(it)} data-testid={`kiosk-deal-toggle-${it.id}`} />
                            {it.image_url ? <img src={it.image_url} alt="" className="w-12 h-12 object-cover" /> : <div className="w-12 h-12 bg-[var(--surface-elevated)]" />}
                            <div className="flex-1 min-w-0">
                                <div className="text-[15px] truncate">{it.name}</div>
                                {!it.image_url && <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted">No photo — slide shows text only</div>}
                            </div>
                            <span className="font-mono text-[12px] text-gold">{formatMoney(it.price)}</span>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
};
